import type { ClaimWorkQueueItem } from '../../../store';
import type { ArchiveSubject } from '../work';
import { resolveHidden } from '../work';

/**
 * What a claim-work row hands packet D's `QueueRowMenu` (GDN-3380).
 *
 * A pure function rather than inline JSX so the wiring is a thing a test can
 * hold. Two derivations matter and neither is obvious:
 *
 * - `encounterId`: the verbs are keyed by ENCOUNTER, because a biller who
 *   archives means the visit, not the one of its three claims they happen to
 *   be looking at. A row with no encounter cannot be dispositioned at all, so
 *   it gets no menu rather than a menu whose items would fail.
 * - `hidden`: the ROW'S OWN boolean, through packet D's `resolveHidden`, and
 *   never re-derived from the disposition here. A returned row and an expired
 *   snooze both carry a non-active disposition and are nonetheless on screen;
 *   reading either as hidden would offer only Restore, so a biller looking at
 *   a claim that has just come back to them could not archive or snooze it
 *   again, which is exactly when they most want to. The server computed
 *   `hidden` against the whole claim family; nothing here can do better.
 */
export interface ClaimQueueRowMenuState {
  encounterId: string | null;
  hidden: boolean;
  subject: ArchiveSubject;
}

export const claimQueueRowMenuState = (
  item: ClaimWorkQueueItem,
  serviceDate: string,
): ClaimQueueRowMenuState => ({
  encounterId: item.encounter_id ?? null,
  hidden: resolveHidden(item.hidden, item.work_disposition),
  subject: {
    patientName: item.patient_name ?? '',
    payerName: item.payer_name ?? '',
    serviceDate,
  },
});
